(function () {
  'use strict';
  if (window.azSignupSessionInstalled) return;
  window.azSignupSessionInstalled = true;

  var script = document.currentScript;
  var isHome = script && script.getAttribute('data-page-type') === 'index';
  var formId = 'SFjfE7';
  var seenKey = 'az_signup_seen_' + formId;
  var submittedKey = 'az_signup_submitted_' + formId;

  function storageAvailable() {
    try {
      var testKey = 'az_signup_storage_test';
      sessionStorage.setItem(testKey, '1');
      sessionStorage.removeItem(testKey);
      localStorage.setItem(testKey, '1');
      localStorage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  }

  // Si no se puede guardar el estado, no abrir automáticamente.
  if (!storageAvailable()) return;

  window.addEventListener('klaviyoForms', function (event) {
    var detail = event.detail || {};
    if (String(detail.formId) !== formId) return;
    try {
      if (detail.type === 'open') sessionStorage.setItem(seenKey, '1');
      if (detail.type === 'submit') {
        localStorage.setItem(submittedKey, '1');
        sessionStorage.setItem(seenKey, '1');
      }
    } catch (error) {}
  });

  if (!isHome) return;
  try {
    if (sessionStorage.getItem(seenKey) === '1' || localStorage.getItem(submittedKey) === '1') return;
    // Reservar antes de encolar para evitar aperturas duplicadas al navegar.
    sessionStorage.setItem(seenKey, '1');
  } catch (error) {
    return;
  }

  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', formId]);
})();
